import type { SortOption } from "$routes/inventory/_lib/sort-by-select";
import { InventorySearchOrderProperty } from "$routes/inventory/_lib/types";
import { useIntl } from "react-intl";

export function useSortByOptions(): Record<
  InventorySearchOrderProperty,
  SortOption
> {
  const { formatMessage } = useIntl();
  return {
    [InventorySearchOrderProperty.NAME]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.alphabetical",
        defaultMessage: "A to Z",
      }),
      field: InventorySearchOrderProperty.NAME,
    },
    [InventorySearchOrderProperty.UPDATED_AT]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.updated_at",
        defaultMessage: "Last Updated",
      }),
      field: InventorySearchOrderProperty.UPDATED_AT,
    },
    [InventorySearchOrderProperty.EXPIRY_DATE]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.expiry_date",
        defaultMessage: "Expiry Date",
      }),
      field: InventorySearchOrderProperty.EXPIRY_DATE,
    },
    [InventorySearchOrderProperty.STOCK_LEVEL]: {
      label: formatMessage({
        id: "inventory.overview.list.sort.option.stock_level",
        defaultMessage: "Quantity",
      }),
      field: InventorySearchOrderProperty.STOCK_LEVEL,
      direction: "ASC",
    },
  };
}
